import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import classes from "./classes.module.scss";
import Row from "./Row";
import ProjectResponseResource from "common/resources/Project/ProjectResponseResource";
import { useCallback } from "react";
import HasSubscriptionPlan from "components/materials/HasSubscriptionPlan";
import { container } from "tsyringe";
import FileService from "services/FileService";

const fileService = container.resolve(FileService);

export type IProps = {
	projectList: ProjectResponseResource[];
	onViewImageClick: (url: string) => void;
	onRowClick: (project: ProjectResponseResource) => void;
	downloadProof: (id: string, title: string) => void;
	onProjectChange: () => void;
};

export default function Table(props: IProps) {
	const onViewImageClick = useCallback(
		(project: ProjectResponseResource) => {
			if (!project.poster?.file?.id) return;
			const posterUrl = fileService.getFileUrl("POSTER", project.poster.file.id);
			props.onViewImageClick(posterUrl);
		},
		[props],
	);

	return (
		<table className={classes["root"]}>
			<thead className={classes["thead"]}>
				<tr>
					<th className={classes["th-name"]}>
						<Typography type="p" weight="bold" size="medium">
							{I18n.trslt(I18n.asset.pages.my_projects.table.headers.project_name)}
						</Typography>
					</th>
					<th className={classes["th-author"]}>
						<Typography type="p" weight="bold" size="medium">
							<HasSubscriptionPlan onNoRightComponent={I18n.trslt(I18n.asset.pages.my_projects.table.headers.author)}>
								{I18n.trslt(I18n.asset.pages.my_projects.table.headers.project_leader)}
							</HasSubscriptionPlan>
						</Typography>
					</th>
					<th className={classes["th-ai-image"]}>
						<Typography type="p" weight="bold" size="medium" className={classes["ellipsis"]}>
							{I18n.trslt(I18n.asset.pages.my_projects.table.headers.ai_image)}
						</Typography>
					</th>
					<th className={classes["th-proof"]}>
						<Typography type="p" weight="bold" size="medium" className={classes["ellipsis"]}>
							{I18n.trslt(I18n.asset.pages.my_projects.table.headers.anchor_proof)}
						</Typography>
					</th>
					<th className={classes["th-status"]}>
						<Typography type="p" weight="bold" size="medium" className={classes["ellipsis"]}>
							{I18n.trslt(I18n.asset.pages.my_projects.table.headers.status)}
						</Typography>
					</th>
					<th className={classes["th-date"]}>
						<Typography type="p" weight="bold" size="medium" className={classes["ellipsis"]}>
							{I18n.trslt(I18n.asset.pages.my_projects.table.headers.date)}
						</Typography>
					</th>
				</tr>
			</thead>

			<tbody className={classes["tbody"]}>
				{props.projectList.map((project) => (
					<Row
						key={project.id}
						project={project}
						onViewImageClick={() => onViewImageClick(project)}
						onRowClick={() => props.onRowClick(project)}
						downloadProof={props.downloadProof}
						onProjectChange={props.onProjectChange}
					/>
				))}
			</tbody>
		</table>
	);
}
